export default {"src":"__ASTRO_ASSET_IMAGE__YS5ngnV2__","width":2500,"height":1667,"format":"jpg"}